import React, { useEffect, useState } from 'react';

import './SuccessPage.css';

import iconClose from './../../image/close.svg';

const SuccessPage = ({ setCurrentPage, setIsShowSuccess, successStatus }) => {
    const [successTitle, setSuccessTitle] = useState('');
    const [successText, setSuccessText] = useState('');

    useEffect(() => {
        if (successStatus === 1) {
            setSuccessTitle('Стол забронирован!');
            setSuccessText(
                'Ожидайте звонка от администратора зала в течении одного часа в рабочее время для подтверждения брони'
            );
        }

        if (successStatus === 2) {
            setSuccessTitle('Ожидайте');
            setSuccessText('Персонал вызван!');
        }

        if (successStatus === 3) {
            setSuccessTitle('Ожидайте');
            setSuccessText('Ваш заказ отправлен!');
        }

        if (successStatus === 4) {
            setSuccessTitle('!');
            setSuccessText('Блюдо добавлено в корзину!');
        }

        if (successStatus === 5) {
            setSuccessTitle('!');
            setSuccessText('Заказ добавлен в корзину!');
        }
    }, [successStatus]);

    const handleOKClick = () => {
        if (successStatus === 1 || successStatus === 2) {
            setCurrentPage('MainPage');
        }
        setIsShowSuccess(false);
    };

    return (
        <div className='success__wrapper'>
            <div className='success__message'>
                <div className='success__close' onClick={handleOKClick}>
                    <img src={iconClose} alt='Close' />
                </div>
                <h1 className='success__title'>{successTitle}</h1>
                <p className='success__message_text'>{successText}</p>
                <button className='success__btn' onClick={handleOKClick}>
                    OK
                </button>
            </div>
        </div>
    );
};

export default SuccessPage;
